import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import NoteIcon from "assets/icons/note.svg?react";
import { useRef, useState } from "react";
import classNames from "classnames";
import { Tooltip } from "@mui/material";
import Popper from "components/Popper";
import NotesModal from "../../NotesModal";
import { useTranslation } from "react-i18next";

const IconsCell: FC<Props> = ({ element, apiRef }) => {
  const { t } = useTranslation();
  const [showNotes, setShowNotes] = useState(false);
  const refWrapper = useRef();
  return (
    <div className={styles.icons}>
      <div className={styles.wrapper} ref={refWrapper}>
        {element.NotesCount > 0 && (
          <div
            onClick={() => {
              setShowNotes(true);
            }}
            className={classNames(styles.box)}
          >
            <Tooltip title={t("tooltips.showNotes")}>
              <div>
                <NoteIcon className={styles.icon} />
              </div>
            </Tooltip>
          </div>
        )}
      </div>
      <Popper
        anchorEl={refWrapper?.current}
        open={showNotes}
        setOpen={setShowNotes}
      >
        <NotesModal
          invoiceId={element.Id}
          toggle={setShowNotes}
          apiRef={apiRef}
        ></NotesModal>
      </Popper>
    </div>
  );
};

export default IconsCell;
